import { Helmet } from "react-helmet";

const NotFound = () => {

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Helmet>
        <title>Page Not Found | Ask4gems</title>
        <meta name="description" content="The page you are looking for could not be found on Ask4gems. Return to the homepage to browse gemstone buying requests." />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Page Not Found | Ask4gems" />
        <meta property="og:description" content="This link is broken or the page no longer exists on Ask4gems." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
